module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki18_pc-61d0108cd0d4aa2b33eec90b00aae383.jpg";